import * as React from 'react';
import ImageWebsiteLogo from './files/ImageWebsiteLogo';

interface FCProps {
  logo: ImageWebsiteLogo;
  onSelect?: (logo: ImageWebsiteLogo) => void;
  selected?: boolean;
  variant?: 'uploader' | 'panel';
  className?: string;
  imgClassName?: string;
}

const LogoImage: React.FC<FCProps> = ({ 
  logo, 
  selected, 
  onSelect, 
  variant = 'uploader',
  className = '',
  imgClassName = '' 
}) => {
  const [imageSrc, setImageSrc] = React.useState<string>('');

  React.useEffect(() => {
    const renderLogoImage = async (logo: ImageWebsiteLogo) => {
      let src = logo.getImageSrc();
      setImageSrc(src);
    };

    renderLogoImage(logo);
  }, [logo]);

  return (
    <div
      className={`${
        variant === 'uploader' 
          ? "w-[50%] sm:w-[33.33%] md:w-[16.66%] box-content m-1 p-2 flex justify-center items-center cursor-pointer"
          : "w-[129px] h-full"
      } ${className}`}
      style={variant === 'uploader' 
        ? {
            border: `2px solid ${selected ? '#52C41A' : 'rgba(0,0,0,0.15)'}`,
            borderRadius: '16px',
            background: '#fff',
            transition: 'border-color 0.2s',
          }
        : {
            background: 'transparent',
          }}
      onClick={() => onSelect && onSelect(logo)}
    >
      <img
        className={`${
          variant === 'uploader'
            ? "w-full h-[216px] object-contain"
            : "w-full object-contain h-full"
        } ${imgClassName}`}
        src={imageSrc}
        alt={logo.getAltText()}
      />
    </div>
  );
};

export default LogoImage;
